import {
	IRequestWithPageSortFilterSearch,
	TFilter,
	TPageRequest,
	TPageResponse,
} from 'redux/types';
import { TUser } from '../user/types';
import { TTableStructureColors, TTableStructureFilter } from '../../../ui/EasTable/types';

export type TGpsrStore = {
	regParser: TGpsrRegParseResponsePayload;
	regParserLoading: boolean;
	regParserError: string;
	registerLoading: boolean;
	registerError: string;
	gpsrPlans: TGpsrPlansResponsePayload;
	gpsrItems: TGpsrItemsResponsePayload;
	gpsrItemsLoading: boolean;
	gpsrProductTypes: TGpsrProductTypesResponsePayload;
	gpsrProductTypesLoading: boolean;
	generateInvoiceGpsrLoading: boolean;
	gpsrRegulations: TGpsrRegulationsResponsePayload;
	gpsrRegulationsLoading: boolean;
	gpsrEditCustomerLoading: boolean;
	gpsrProductTypeReferences: TGetProductTypeReferencesResponsePayload;
	gpsrProductTypeReferencesLoading: boolean;
	gpsrProductTypeRegulationsGroupTypes: TGetProductTypeRegulationsGroupTypesResponsePayload;
	gpsrProductTypeRegulationsGroupTypesLoading: boolean;
	gpsrProductTypeRegulationsReferences: TGetProductTypeRegulationsReferencesResponsePayload;
	gpsrProductTypeRegulationsReferencesLoading: boolean;
	gpsrRegulationsReferences: TGetRegulationsReferencesResponsePayload;
	gpsrRegulationsReferencesLoading: boolean;
	gpsrTechFile: TGetTechFileResponsePayload;
	gpsrTechFileLoading: boolean;
	gpsrDocFile: TGetDocFileResponsePayload;
	gpsrDocFileLoading: boolean;
	cancelGpsrLoading: boolean;
	activateGpsrLoading: boolean;
	downloadGpsrLastInvoiceLoading: boolean;
	getInvoicesList: TGetInvoicesListResponsePayload;
	getInvoicesListLoading: boolean;
	downloadGpsrInvoice: TDownloadGpsrInvoiceResponsePayload;
	downloadGpsrInvoiceLoading: boolean;
	updateGpsrServiceSettingsLoading: boolean;
	updateGpsrRemoveOnRenewalLoading: boolean;
	changeGpsrStatusLoading: boolean;
	gpsrReferralLoading: boolean;
	gpsrReferralError: string;
	gpsrServiceStatuses: TGpsrServiceStatusesResponsePayload;
	gpsrServiceStatusesLoading: boolean;
};

// ==========================================:

export type TGpsrRegParseRequest = {
	urlEncodedRawRegistrationData: string;
};

export type TGpsrRegParse = {
	sellingTypeOfProducts?: string;
	isSellingToEU?: boolean;
	sellingPlace?: string;
	firstName?: string;
	lastName?: string;
	phoneNumber?: string;
	email?: string;
	company?: string;
	address1?: string;
	address2?: string;
	cityTown?: string;
	stateRegionProvince?: string;
	zipCode?: string;
	country?: string;
	businessRegistrationNumber?: string;
	storeAddress?: string;
	numberOfAdditionalProductTypes?: number;
	subscriptionPlanId?: number;
	periodStart?: string;
	periodEnd?: string;
	id?: number;
	newNumberOfAdditionalProducts?: number;
	newPlanId?: number;
	emId?: number;
};

export type TGpsrRegisterRequest = TGpsrRegParse;

export type TGpsrRegParseResponsePayload = TGpsrRegParse | null;

// ==========================================:

export type TGpsrEditCustomerRequest = {
	id: number;
	emId?: number;
	numberOfAdditionalProductTypes: number;
	subscriptionPlanId: number;
	periodStart: string;
	periodEnd: string;
};

// ==========================================:

export type TGpsrPlan = {
	id: number;
	name: string;
	amount: number;
	includedTypes: number;
	pricePerAdditionalType: number;
	userVisibleName: string;
};

export type TGpsrPlans = TGpsrPlan[];

export type TGpsrPlansResponsePayload = TGpsrPlans | null;

// ==========================================:

export type TGpsrServiceStatus = {
	id: number;
	name: string;
	displayName: string;
	description: string;
};

export type TGpsrServiceStatuses = TGpsrServiceStatus[];

export type TGpsrServiceStatusesResponsePayload = TGpsrServiceStatuses | null;

// ==========================================:

// {
//   "pageSize": 0,
//   "pageNumber": 0,
//   "filters": [
//     {
//       "fieldName": "string",
//       "value": "string",
//       "operator": "string"
//     }
//   ],
//   "orderBy": [
//     {
//       "fieldName": "string",
//       "direction": "string"
//     }
//   ],
//   "searchString": "string"
// }

export type TGpsrItemsRequest = IRequestWithPageSortFilterSearch;

// "id": 3,
// "emName": "The Good Book Company Limited test",
// "numberOfAdditionalProductTypes": 0,
// "periodStart": "2024-12-03T00:00:00",
// "periodEnd": "2025-12-31T00:00:00",
// "createdAt": "2024-12-03T13:52:26.320277Z",
// "author": {
//     "id": "74ce3b5e-a492-49ae-8d8a-8609b275805d",
//     "email": "andrii@easproject.com",
//     "fullName": "Andrii"
// },
// "subscriptionPlanId": 3,
// "subscriptionPlanName": "Level6",
// "invoiceId": 12000010

export enum EConfirmationStatus {
	CONFIRMED = 'Confirmed',
	WAITING_CONFIRMATION = 'Waiting Confirmation',
}

export enum EPaymentStatus {
	PAID = 'paid',
	PENDING = 'pending',
	PARTIALLY_PAID = 'partially_paid',
}
// ['eas_not_started', 'No Products Added'],
// ['em_not_starter', 'No SKU added'],
// ['em_sku_started', 'No DoC started'],
// ['em_not_finished', 'No all DoC finished'],
// ['all_is_done', 'All is Done'],

export enum EProductStatus {
	EAS_NOT_STARTED = 'eas_not_started',
	EM_NOT_STARTER = 'em_not_starter',
	EM_SKU_STARTED = 'em_sku_started',
	EM_NOT_FINISHED = 'em_not_finished',
	ALL_IS_DONE = 'em_finished',
}
// 1	Renewal Notified	renewal email sent
// 2	Invoiced	new invoice generated
// 3	Active	last invoice paid and not due for renewal
// 4	Disabled	service disabled
// 5	Cancelled	subscription cancelled
// 6	Registration	initial registration status
export enum EServiceStatus {
	RENEWAL_NOTIFIED = 'Renewal Notified',
	INVOICED = 'Invoiced',
	ACTIVE = 'Active',
	DISABLED = 'Disabled',
	CANCELLED = 'Cancelled',
	REGISTRATION = 'Registration',
	SUSPENDED = 'Suspended',
}

export enum EServiceStatusID {
	RENEWAL_NOTIFIED = 1,
	INVOICED = 2,
	ACTIVE = 3,
	DISABLED = 4,
	CANCELLED = 5,
	REGISTRATION = 6,
	SUSPENDED = 39,
}

export const SERVICE_STATUSES = [
	{
		id: EServiceStatusID.RENEWAL_NOTIFIED,
		name: EServiceStatus.RENEWAL_NOTIFIED,
		color: 'info.light',
	},
	{
		id: EServiceStatusID.INVOICED,
		name: EServiceStatus.INVOICED,
		color: 'info.light',
	},
	{ id: EServiceStatusID.ACTIVE, name: EServiceStatus.ACTIVE, color: 'success.light' },
	{ id: EServiceStatusID.DISABLED, name: EServiceStatus.DISABLED, color: 'error.light' },
	{
		id: EServiceStatusID.CANCELLED,
		name: EServiceStatus.CANCELLED,
		color: 'warning.light',
	},
	{
		id: EServiceStatusID.REGISTRATION,
		name: EServiceStatus.REGISTRATION,
		color: 'warning.light',
	},
	{
		id: EServiceStatusID.SUSPENDED,
		name: EServiceStatus.SUSPENDED,
		color: 'warning.light',
	},
];

export const GPSR_SERVICE_STATUSES_FILTER_COLORS: TTableStructureColors = [
	[EServiceStatus.RENEWAL_NOTIFIED, 'info.light'],
	[EServiceStatus.INVOICED, 'info.light'],
	[EServiceStatus.ACTIVE, 'success.light'],
	[EServiceStatus.DISABLED, 'error.light'],
	[EServiceStatus.CANCELLED, 'warning.light'],
	[EServiceStatus.REGISTRATION, 'warning.light'],
	[EServiceStatus.SUSPENDED, 'warning.light'],
];

export type TGpsrItem = {
	id: number;
	emId: number;
	emName: string;
	numberOfAdditionalProductTypes: number;
	periodStart: string;
	periodEnd: string;
	createdAt: string;
	author: TUser;
	subscriptionPlanId: number;
	subscriptionPlanName: string;
	invoiceId: number;
	paymentStatus: EPaymentStatus;
	productStatus: EProductStatus;
	serviceStatusName: EServiceStatus;
	serviceStatusId: EServiceStatusID;
	updatedAt: string;
	updatedBy: TUser;
	allowEditing: boolean;
	confirmationStatus: EConfirmationStatus;
	confirmedBy: TUser;
};

export type TGpsrItems = TGpsrItem[];

export type TGpsrItemsResponse = TPageResponse<TGpsrItem>;

export type TGpsrItemsResponsePayload = TGpsrItemsResponse | null;

// ==========================================:

export interface IGpsrProductTypesRequest extends TPageRequest {
	emId: number;
	searchString: string;
}

// {
// 	"id": 3,
// 	"name": "test 4",
// 	"description": "test4",
// 	"createdAt": "2024-12-04T12:58:00.630791Z",
// 	"author": {
// 		"id": "74ce3b5e-a492-49ae-8d8a-8609b275805d",
// 		"email": "andrii@easproject.com",
// 		"fullName": "Andrii"
// 	}
// },

export type TGpsrProductType = {
	id: number;
	name: string;
	description: string;
	createdAt: string;
	author: TUser;
	productTypeId: number | null;
	removeOnRenewal: boolean;
};

export interface IGpsrProductTypes extends TPageResponse<TGpsrProductType> {
	merchant: TGpsrItem;
}

export type TGpsrProductTypesResponsePayload = IGpsrProductTypes | null;

// ==========================================:

export type TAddGpsrProductTypeBodyRequest = {
	id: number | null;
	name: string;
	description: string;
	productTypeId: number | null;
};

export type TAddGpsrProductTypeRequest = {
	emId: number;
	body: TAddGpsrProductTypeBodyRequest;
	request: IGpsrProductTypesRequest;
};

// ==========================================:

export type TDeleteGpsrProductTypeRequest = {
	emId: number;
	productTypeId: number;
	request: IGpsrProductTypesRequest;
};

// ==========================================:

export type TGenerateGpsrInvoiceRequest = {
	invoiceId: number;
};

// ==========================================:

export type TGpsrRegulationsRequest = {
	emId: number;
	productTypeId: number;
};

export type TGpsrRegulationsItem = {
	id: number;
	emId: number;
	productTypeId: number;
	name: string;
	regulationId: number;
};

export type TGpsrRegulationsResponse = TGpsrRegulationsItem[];

export type TGpsrRegulationsResponsePayload = TGpsrRegulationsResponse | null;

// ==========================================:

export type TAddGpsrRegulationsBodyRequest = {
	id: number | null;
	name: string;
	regulationId: number | null;
};

export type TAddGpsrRegulationsRequest = {
	emId: number;
	productTypeId: number;
	body: TAddGpsrRegulationsBodyRequest;
};

// ==========================================:

export type TDeleteGpsrRegulationsRequest = {
	emId: number;
	productTypeId: number;
	regulationId: number;
};

// ==========================================:

// GET_PRODUCT_TYPE_REFERENCES: (emId: number, productTypeId: number) => `/api/product_types`,

// 		GET_PRODUCT_TYPE_REGULATIONS: (emId: number, productTypeId: number) =>
// 			`/api/product_type_regulations/group_types`,
// 		GET_PRODUCT_TYPE_REGULATIONS_REFERENCES: (emId: number, productTypeId: number) =>
// 			`/api/product_type_regulations/${emId}/${productTypeId}`,
// 	},

export type TGetProductTypeReferencesRequest = IRequestWithPageSortFilterSearch;

export type TGetProductTypeReferences = {
	id: number;
	typeName: string;
	defaultDescription: string;
	createdAt: string;
	author: TUser;
};
// export type TMtdReportsItemResponse<T> = TPageResponse<T>;
// export type TMtdReportsItemResponsePayload<T> = TMtdReportsItemResponse<T> | null;

export type TGetProductTypeReferencesResponse = TPageResponse<TGetProductTypeReferences>;

export type TGetProductTypeReferencesResponsePayload = TGetProductTypeReferencesResponse | null;

// ==========================================:

export type TGetProductTypeRegulationsGroupTypesRequest = IRequestWithPageSortFilterSearch;

export type TGetProductTypeRegulationsGroupTypesResponse = {
	id: number;
	name: string;
};

export type TGetProductTypeRegulationsGroupTypesResponsePayload =
	TGetProductTypeRegulationsGroupTypesResponse | null;

// ==========================================:

export type TGetProductTypeRegulationsReferencesRequest = IRequestWithPageSortFilterSearch;

export type TGetProductTypeRegulationsReferencesResponse = {
	id: number;
	name: string;
};

export type TGetProductTypeRegulationsReferencesResponsePayload =
	TGetProductTypeRegulationsReferencesResponse | null;

// ==========================================:

export type TGetRegulationsReferencesRequest = IRequestWithPageSortFilterSearch;

export type TGetRegulationsReferences = {
	id: number;
	regulName: string;
	regulYear: number;
	regulNumber: string;
	createdAt: string;
	author: TUser;
};

export type TGetRegulationsReferencesResponse = TPageResponse<TGetRegulationsReferences>;

export type TGetRegulationsReferencesResponsePayload = TGetRegulationsReferencesResponse | null;

// ==========================================:

export type TGetTechFileRequest = {
	emId: number;
	productTypeId: number;
};

export type TGetTechFileResponse = Blob;

export type TGetTechFileResponsePayload = TGetTechFileResponse | null;

// ==========================================:

export type TGetDocFileRequest = {
	emId: number;
	productTypeId: number;
};

export type TGetDocFileResponse = Blob;

export type TGetDocFileResponsePayload = TGetDocFileResponse | null;

// ==========================================:

export type TCancelGpsrRequest = {
	id: number;
	request: IGpsrProductTypesRequest;
};

export type TActivateGpsrRequest = {
	id: number;
	request: IGpsrProductTypesRequest;
};

// ==========================================:

export type TDownloadGpsrLastInvoiceRequest = {
	id: number;
};

export type TDownloadGpsrLastInvoiceResponse = Blob;

export type TDownloadGpsrLastInvoiceResponsePayload = TDownloadGpsrLastInvoiceResponse | null;

// ==========================================:

export type TGetInvoicesListRequest = IRequestWithPageSortFilterSearch;

export type TGetInvoicesListResponse = TPageResponse<TGetInvoicesListResponseItem>;

export type TGetInvoicesListResponseItem = {
	invoiceId: number;
	invoiceNumber: number;
	emId: number;
	dateTime: string;
	amount: number;
	paymentStatus: EPaymentStatus;
	emName: string;
};

export type TGetInvoicesListResponsePayload = TGetInvoicesListResponse | null;

// ==========================================:

export type TDownloadGpsrInvoiceRequest = {
	emId: number;
	invoiceId: number;
};

export type TDownloadGpsrInvoiceResponse = Blob;

export type TDownloadGpsrInvoiceResponsePayload = TDownloadGpsrInvoiceResponse | null;

// ==========================================:

export type TUpdateGpsrServiceSettingsRequest = {
	stopNotifications: boolean;
	id: number;
};

// ==========================================:

export type TUpdateGpsrRemoveOnRenewalRequest = {
	emId: number;
	id: number;
	removeOnRenewal: boolean;
};

// ==========================================:

export type TChangeGpsrStatusRequest = {
	id: number;
	statusId: EServiceStatusID;
	request: IGpsrProductTypesRequest;
};

export type TChangeGpsrStatusResponse = {
	message: string;
};

export type TChangeGpsrStatusResponsePayload = TChangeGpsrStatusResponse | null;

// ==========================================:

export type TGpsrReferralRequest = {
	emId: number;
	referralId: number;
};
